import { Injectable } from '@angular/core';
import { AttachmentFile } from '@warema/shared/models';

@Injectable({
    providedIn: 'root',
})
export class FileValidationService {
    public isFileValid(fileName: string, files: Array<AttachmentFile>, acceptedExtensions: string): boolean {
        return (
            !!fileName &&
            this._isFileExtensionValid(fileName, acceptedExtensions) &&
            !this._isFilenameDuplicate(fileName, files)
        );
    }

    private _isFileExtensionValid(fileName: string, acceptedExtensions: string): boolean {
        const fileExtension = `.${this.getFileExtension(fileName)}`;
        return acceptedExtensions.split(',').includes(fileExtension);
    }

    private _isFilenameDuplicate(fileName: string, files: Array<AttachmentFile>): boolean {
        return files.some(x => x.name === fileName);
    }

    public isFileSizeValid(file: File, maxFileSize: number): boolean {
        const fileSize = file.size / 1024 / 1024;
        return fileSize < maxFileSize;
    }

    public getFileExtension(filename: string): string {
        return /[.]/.exec(filename) ? (/[^.]+$/.exec(filename)?.[0].toLowerCase() ?? '') : '';
    }
}
